(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-and-buy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.wb-slider', {
      slidesPerView: 4,
      spaceBetween: 16,

      navigation: {
        nextEl: '.wb-next',
        prevEl: '.wb-prev',
      },

      breakpoints: {
        0: {
          slidesPerView: 1.2,
        },
        768: {
          slidesPerView: 2.2,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yk-testimonial"] && !Shopify.designMode) return;
  try {
    
function initYKTestimonialSlider() {
  document.querySelectorAll('.yk-testimonial-section').forEach((section) => {
    const slider = section.querySelector('.yk-testimonial-slider');

    if (!slider) return;

    // Prevent duplicate initialization
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    new Swiper(slider, {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true,
      speed: 600,

      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', initYKTestimonialSlider);
document.addEventListener('shopify:section:load', initYKTestimonialSlider);

  } catch(e) { console.error(e); }
})();
})();
